import { render, staticRenderFns } from "./exits.vue?vue&type=template&id=58ad87a4&scoped=true"
import script from "./exits.vue?vue&type=script&lang=js"
export * from "./exits.vue?vue&type=script&lang=js"
import style0 from "./exits.vue?vue&type=style&index=0&id=58ad87a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ad87a4",
  null
  
)

export default component.exports